import { LogTimestamp } from "../value-objects";
import { UUIDIdentity } from "../value-objects/identity/identity";
import { LogRecord } from "./log-record";
export class BaseLogRecord {
    id;
    v;
    constructor(value) {
        this.id = value.id;
        this.v = value;
    }
    toValues() {
        return LogRecord.toJson(this);
    }
    static setBasic() {
        return {
            id: UUIDIdentity.generate(),
            timestamp: LogTimestamp.new(),
        };
    }
}
//# sourceMappingURL=base-log-record.js.map